import { useEffect } from 'react';
import { applyHostBrandingMeta } from '../utils/hostBranding';

/**
 * Ersatz für Pre-Login-Seiten (Forgot/Reset Password, Verify Email, Register),
 * die auf einer Whitelabel-Domain nicht funktionieren. Zeigt eine freundliche
 * Hinweis-Karte im Branding des Hosts an statt des WerkPilot-Formulars.
 *
 * Wird in den jeweiligen Seiten als Early-Return gerendert, wenn
 * `hostBranding?.passwordFlowHandledExternally === true`.
 */
export default function HostBrandedNotice({ hostBranding, title, message, pageTitle }) {
  useEffect(() => applyHostBrandingMeta(hostBranding, pageTitle), [hostBranding, pageTitle]);

  const accent = hostBranding?.accent || '#378ab2';
  const displayName = hostBranding?.name || 'Portal';
  const fontFamily = hostBranding?.fontFamily || "'Montserrat', sans-serif";

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="bg-surface p-8 rounded-card shadow-card w-full max-w-md text-center">
        <div
          className="w-20 h-20 mx-auto mb-5 rounded-full flex items-center justify-center"
          style={{ backgroundColor: accent }}
        >
          <span className="text-white text-3xl font-bold" style={{ fontFamily }}>
            {displayName.substring(0, 2)}
          </span>
        </div>
        <h1 className="text-2xl font-bold mb-3 text-gray-900" style={{ fontFamily }}>
          {title}
        </h1>
        <p className="text-text-muted leading-relaxed">{message}</p>
      </div>
    </div>
  );
}
